import { Typography } from "@lyfegen-platform/react-common";
import { makeStyles, Theme, Tooltip, TooltipProps, TypographyProps } from "@material-ui/core";
import { boxShadow } from "../hooks/use-map-theme-styles";

export interface LyfeTooltipProps {
	variant?: "dark" | "light" | "invisible";
	maxWidth?: string;
	leaveDelay?: number;
}

const LyfeTooltip: React.FC<TooltipProps & { typographyProps?: TypographyProps } & LyfeTooltipProps> = (props) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { variant, maxWidth, title, typographyProps, ...other } = props;
	const { tooltip } = classes({ variant, maxWidth });

	return (
		<Tooltip
			enterDelay={100}
			leaveDelay={props.leaveDelay ?? 0}
			title={
				props.title ? (
					typeof props.title === "string" ? (
						<Typography {...typographyProps} type="semi-bold">
							{props.title}
						</Typography>
					) : (
						props.title
					)
				) : (
					""
				)
			}
			classes={{
				tooltip,
			}}
			{...other}
		>
			{props.children}
		</Tooltip>
	);
};

const classes = makeStyles<Theme & LyfeTooltipProps>((theme: Theme) => {
	const { spacing, palette } = theme;

	const getColor = (variant?: "dark" | "light" | "invisible") => {
		switch (variant) {
			case "dark":
				return (palette.toolTipBg as any)?.main || "black";
			case "light":
				return "white";
			case "invisible":
				return "transparent";
			default:
				return (palette.toolTipBg as any)?.main || "black";
		}
		return "white";
	};

	return {
		tooltip: {
			backgroundColor: (props) => getColor((props as LyfeTooltipProps)?.variant),
			color: (props) => ((props as LyfeTooltipProps)?.variant === "light" ? "black" : "white"),
			padding: spacing(1),
			boxShadow: (props) => ((props as LyfeTooltipProps)?.variant === "invisible" ? "none" : boxShadow),
			maxWidth: (props) => (props as LyfeTooltipProps)?.maxWidth,
		},
	};
});

export default LyfeTooltip;
